/**
 * @file: MemberPickerPanel.tsx
 *
 * Multi-select member picker in a panel — create a group or invite members
 * into a room. A thin `BottomPanel` wrapper around the shared
 * `ChatContactPickerView` (new-group / invite modes); the outcome is reported
 * via `onDone` and the host acts on it.
 */

import {
  ChatContactPickerParams,
  ChatPickerDoneResult,
} from '@euler/app/flows/chat/lib/types';
import { BottomPanel } from '@euler/components/BottomPanel';
import { FC, memo } from 'react';
import { ChatContactPickerView } from '../pages/contact-picker/components/ChatContactPickerView';

export const MemberPickerPanel: FC<{
  visible: boolean;
  params: ChatContactPickerParams;
  onDone: (result: ChatPickerDoneResult) => void;
  onClose: () => void;
}> = memo(({ visible, params, onDone, onClose }) => (
  <BottomPanel visible={visible} onClose={onClose}>
    <ChatContactPickerView
      embedded
      params={params}
      onDone={onDone}
      onCancel={onClose}
    />
  </BottomPanel>
));
